<template>
    <label :for="id" :class="labelClasses">
        {{ label }} <span v-if="required">*</span>
    </label>
</template>


<script>
export default {
    props: {
        label: {
            type: String,
        },
        id: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'text',
        }
    },
    computed: {
        labelClasses() {
            if (this.type == 'radio' || this.type == 'checkbox') {
                return 'flex-initial order-1 pl-1';
            } else {
                return 'flex-auto pr-2 font-bold';
            }
        },
    },
}
</script>
